import React from 'react';
import { Control, FieldErrors } from 'react-hook-form';
import { TicketHolderFields } from '../../../../../../surveys/containers/SurveyResponses/EventRegistration/components/EventSurvey/EventSurveyForm/components/TicketHolderFields';
import { IEventTicket } from '../../../../../../surveys/models/Api';
import { IFormValues, ITicketHolder } from './types';

interface PreviewTicketHolderFieldsProps {
	tickets: IEventTicket[];
	ticketSelections: Record<string, number>;
	ticketHolders: ITicketHolder[];
	control: Control<IFormValues>;
	errors: FieldErrors<IFormValues>;
	primaryTicketHolderId: string | null;
	onPrimaryTicketHolderChange: (id: string) => void;
	requireGuestNames?: boolean;
	requirePhoneNumber?: boolean;
}

/**
 * Preview wrapper for TicketHolderFields component
 * Disables all interactions for preview mode
 */
export const PreviewTicketHolderFields: React.FC<PreviewTicketHolderFieldsProps> = ({
	tickets,
	ticketSelections,
	ticketHolders,
	control,
	errors,
	primaryTicketHolderId,
	onPrimaryTicketHolderChange,
	requireGuestNames = false,
	requirePhoneNumber = false,
}) => {
	return (
		<TicketHolderFields
			tickets={tickets}
			ticketSelections={ticketSelections}
			ticketHolders={ticketHolders}
			control={control}
			errors={errors}
			disabled={true}
			primaryTicketHolderId={primaryTicketHolderId}
			onPrimaryTicketHolderChange={onPrimaryTicketHolderChange}
			requireGuestNames={requireGuestNames}
			requirePhoneNumber={requirePhoneNumber}
		/>
	);
};
